import { get, keyBy, uniq } from "lodash";

/**
 * Resolves the product label shown in quote emails by matching each plan's
 * `insurancePlan.product` code against organization ProductRange entries.
 * Distinct labels are joined with ", "; unmatched codes are shown as-is.
 */
export const resolveProductName = ({
  productCodes = [],
  productRanges = [],
}) => {
  const codes = uniq((productCodes || []).filter(Boolean));
  if (!codes.length) return "";

  const rangeByCode = keyBy(productRanges, "code");
  const labels = codes.map(
    (code) => get(rangeByCode, [code, "label"]) || code,
  );
  return uniq(labels).join(", ");
};
